const returnLanguageCode = (Language) => {
  let languageCode;
  switch(Language) {
    case 'danish':
      languageCode = 'da';
      break;
    case 'swedish':
      languageCode = 'sv';
      break;
    case 'norwegian':
      languageCode = 'no';
      break;
    case 'finnish':
      languageCode = 'fi';
      break;
    default:
      languageCode = 'da';
      break;
  }
  return languageCode;
};

exports.returnLanguageCode = returnLanguageCode;
